import { useSelector } from "react-redux";

import { setBlockSelectors } from "../services/stepThree";
import { configDataSelector } from "../../../services/general/selectors";

const useInitialData = ({ template_code }) => {
    const { templates } = useSelector(configDataSelector);
    const currentTemplate = templates?.find((template) => template.code === template_code);

    if(currentTemplate?.block_selectors) {
        setBlockSelectors(currentTemplate.block_selectors);
    }
};

export default useInitialData;
